// // src/services/bookingWebSocket.js
// /**
//  * WebSocket service for real-time booking notifications
//  * wss://aeroviewbackend.dockyardsoftware.com:8095/Booking
//  *
//  * When employee submits a booking, it sends to this WS
//  * Driver dashboard listens to the same WS and displays popup in real time
//  */

// class BookingWebSocket {
//   constructor() {
//     this.ws = null;
//     this.isConnected = false;
//     this.reconnectAttempts = 0;
//     this.maxReconnectAttempts = 10;
//     this.reconnectDelay = 2000;
//     this.authKey = null;
//     this.driverSno = null;
//     this.vehicleId = null;
//     this.onBookingCallback = null;
//      this.statusUpdateListeners = [];
//     this.bookingAlertListeners  = [];  
//     this.WS_URL = "wss://aeroviewbackend.dockyardsoftware.com:8095/Booking";
//   }

//   /**
//    * Connect to booking WS server (for drivers to receive bookings)
//    * @param {string} authKey - authentication token
//    * @param {string} driverSno - driver's service number
//    * @param {string} vehicleId - driver's assigned vehicle ID
//    */
//   connect(authKey, driverSno, vehicleId) {
//     if (!authKey || !driverSno) { 
//       return;
//     }

//     this.authKey = authKey;
//     this.driverSno = driverSno;
//     this.vehicleId = vehicleId;

//     if (
//       this.ws &&
//       (this.ws.readyState === WebSocket.OPEN ||
//         this.ws.readyState === WebSocket.CONNECTING)
//     ) { 
//       return;
//     }

//     this.disconnect();

//     try {
//       const url = this.WS_URL + "?token=" + encodeURIComponent(authKey);
 
//       this.ws = new WebSocket(url);

//       this.ws.onopen = () => {
//         this.isConnected = true;
//         this.reconnectAttempts = 0;
  
//         try {
//           this.ws.send(
//             JSON.stringify({
//               type: "subscribe",
//               action: "driver_subscribe",
//               token: authKey,
//               driverSno: driverSno,
//               vehicleId: vehicleId,
//             }),
//           );
 
//         } catch (e) {
         
//         }
//       };

//       this.ws.onmessage = (evt) => {
//         try {
//           const msg = JSON.parse(evt.data); 

//           // 🔴 NEW: Handle booking cancellation messages (from employee cancelling PENDING booking)
//           // if (
//           //   msg.type === "booking_cancelled" ||
//           //   msg.action === "booking_cancelled"
//           // ) {
//           //   console.log(
//           //     "[BookingWS] 📥 Booking cancellation received:",
//           //     msg.bId,
//           //   );
//           //   if (this.onBookingCallback) {
//           //     this.onBookingCallback(msg);
//           //   }
//           //   return; // Exit early, don't process as new booking
//           // }

//           if (
//             msg.type === "booking_cancelled" ||
//             msg.action === "booking_cancelled"
//           ) {
             
//             if (this.onBookingCallback) {
//               this.onBookingCallback(msg);
//             }
//             return;
//           }

//           // Check if this is a booking notification for this driver
//           if (
//             msg.type === "new_booking" ||
//             msg.type === "booking" ||
//             msg.dSNo ||
//             msg.vId
//           ) {
//             // Only process if this booking is for this driver's vehicle
//             if (
//               msg.dSNo === this.driverSno ||
//               msg.vId === this.vehicleId ||
//               !msg.dSNo
//             ) { 
//               if (this.onBookingCallback) {
//                 this.onBookingCallback(msg);
//               }
//             }
//           }
//         } catch (e) { 
//         }
//       };

//       this.ws.onerror = (err) => { 
//       };

//       this.ws.onclose = () => {
//         this.isConnected = false; 
//         this.attemptReconnect();
//       };
//     } catch (err) { 
//       this.attemptReconnect();
//     }
//   }

//   /**
//    * Send a booking notification (called by employee when submitting a booking)
//    * @param {object} bookingData - the booking details
//    */
  
//   sendBooking(bookingData) {
//     if (!this.ws || this.ws.readyState !== WebSocket.OPEN) { 
//       return false;
//     }

//     try {
//       const message = {
//         type: "new_booking",
//         action: "create_booking",
//         ...bookingData,
//         timestamp: new Date().toISOString(),
//       };
//       this.ws.send(JSON.stringify(message)); 
//       return true;
//     } catch (e) { 
//       return false;
//     }
//   }

//   /**
//    * 🔴 NEW: Send booking status update (called by driver when changing status)
//    * @param {object} statusData - { bId, status, dlatitude, dlongitude, vId, dSNo, ... }
//    */

//   sendStatusUpdate(statusData) {
//     if (!this.ws || this.ws.readyState !== WebSocket.OPEN) { 
//       return false;
//     }

//     try {
//       const message = {
//         type: "booking_status_update",
//         action: "update_status",
//         ...statusData,
//         timestamp: new Date().toISOString(),
//       };
//       this.ws.send(JSON.stringify(message)); 
//       return true;
//     } catch (e) {
       
//       return false;
//     }
//   }

//   /**
//    * 🔴 NEW: Send booking cancellation message (called by employee when cancelling a pending booking)
//    * @param {object} cancellationData - { bId, dSNo, vId, ... }
//    */
//   sendCancellation(cancellationData) {
//     if (!this.ws || this.ws.readyState !== WebSocket.OPEN) {
       
//       return false;
//     }

//     try {
//       const message = {
//         type: "booking_cancelled",
//         action: "booking_cancelled",
//         ...cancellationData,
//         timestamp: new Date().toISOString(),
//       };
//       this.ws.send(JSON.stringify(message));
     
//       return true;
//     } catch (e) {
       
//       return false;
//     }
//   }

//   /**
//    * Connect as employee to send bookings
//    * @param {string} authKey - authentication token
//    */
//   connectAsEmployee(authKey) {
//     if (!authKey) {
      
//       return;
//     }

//     this.authKey = authKey;

//     if (
//       this.ws &&
//       (this.ws.readyState === WebSocket.OPEN ||
//         this.ws.readyState === WebSocket.CONNECTING)
//     ) {
     
//       return;
//     }

//     this.disconnect();

//     try {
//       const url = this.WS_URL + "?token=" + encodeURIComponent(authKey);
    
//       this.ws = new WebSocket(url);

//       this.ws.onopen = () => {
//         this.isConnected = true;
//         this.reconnectAttempts = 0;
        

//         // Send auth message
//         try {
//           this.ws.send(
//             JSON.stringify({
//               type: "auth",
//               action: "employee_connect",
//               token: authKey,
//             }),
//           );
//         } catch (e) {
        
//         }
//       };

//       this.ws.onmessage = (evt) => {
//         try {
//           const msg = JSON.parse(evt.data);
         

//           // 🔴 NEW: Handle status update messages from backend
//           // if (msg.type === "booking_status_update" || msg.type === "status_update" || (msg.bId && msg.status)) {
//           //   console.log("[BookingWS] 📊 Status update message:", msg);
//           // Handle status update / cancellation messages from backend
//           if (
//             msg.type === "booking_status_update" ||
//             msg.type === "status_update" ||
//             msg.type === "booking_cancelled" ||
//             msg.action === "booking_cancelled" ||
//             (msg.bId && msg.status)
//           ) {
             
//             // Notify all listeners
//             this.statusUpdateListeners.forEach((listener) => {
//               try {
//                 listener(msg);
//               } catch (e) {
             
//               }
//             });
//           }

//           // Handle other booking messages
//           if (
//             msg.type === "new_booking" ||
//             msg.type === "booking_accepted" ||
//             msg.type === "booking_rejected"
//           ) {
//             if (this.onBookingCallback) {
//               this.onBookingCallback(msg);
//             }
//           }
//         } catch (e) {
           
//         }
//       };

//       this.ws.onerror = (err) => {
         
//       };

//       this.ws.onclose = () => {
//         this.isConnected = false;
//      this.attemptReconnect();
//       };
//     } catch (err) {
      
//     }
//   }

//   /**
//    * Set callback for when a new booking is received (for drivers)
//    * @param {function} callback - function to call with booking data
//    */
//   onNewBooking(callback) {
//     this.onBookingCallback = callback;
//   }

//   /**
//    * 🔴 NEW: Add callback for status updates (supports multiple listeners)
//    * @param {function} callback - function to call with status update data
//    * @returns {function} unsubscribe function
//    */
//   onStatusUpdate(callback) {
//     if (callback && typeof callback === "function") {
//       this.statusUpdateListeners.push(callback);
 
//       return () => {
//         this.statusUpdateListeners = this.statusUpdateListeners.filter(
//           (cb) => cb !== callback,
//         );
 
//       };
//     }
//     // If null passed, clear all (legacy support, but discouraged)
//     if (callback === null) {
     
//       this.statusUpdateListeners = [];
//     }
//   }

//   /**
//    * Check if WebSocket is ready
//    */
//   isReady() {
//     return this.ws && this.ws.readyState === WebSocket.OPEN;
//   }

//   /**
//    * Attempt to reconnect after connection lost
//    */
//   attemptReconnect() {
//     if (this.reconnectAttempts >= this.maxReconnectAttempts) {
    
//       return;
//     }

//     this.reconnectAttempts++;
 

//     setTimeout(() => {
//       if (this.driverSno) {
//         this.connect(this.authKey, this.driverSno, this.vehicleId);
//       } else {
//         this.connectAsEmployee(this.authKey);
//       }
//     }, this.reconnectDelay * this.reconnectAttempts);
//   }

//   /**
//    * Disconnect from WebSocket
//    */
//   disconnect() {
//     if (this.ws) {
//       try {
//         this.ws.close();
//       } catch (e) {
        
//       }
//       this.ws = null;
//     }
//     this.isConnected = false;
 
//   }
// }

// // Export singleton instance
// const bookingWS = new BookingWebSocket();
// export default bookingWS;








/**
 * WebSocket service for real-time booking notifications
 * wss://aeroviewbackend.dockyardsoftware.com:8095/Booking
 *
 * When employee submits a booking, it sends to this WS
 * Driver dashboard listens to the same WS and displays popup in real time
 */

class BookingWebSocket {
  constructor() {
    this.ws = null;
    this.isConnected = false;
    this.reconnectAttempts = 0;
    this.maxReconnectAttempts = 10;
    this.reconnectDelay = 2000;
    this.authKey = null;
    this.driverSno = null;
    this.vehicleId = null;
    this.onBookingCallback = null;
    this.statusUpdateListeners = [];
    this.bookingAlertListeners = [];
    this.WS_URL = "wss://aeroviewbackend.dockyardsoftware.com:8095/Booking";
  }

  /**
   * Connect to booking WS server (for drivers to receive bookings)
   * @param {string} authKey - authentication token
   * @param {string} driverSno - driver's service number
   * @param {string} vehicleId - driver's assigned vehicle ID
   */
  connect(authKey, driverSno, vehicleId) {
    if (!authKey || !driverSno) {
      return;
    }

    this.authKey = authKey;
    this.driverSno = driverSno;
    this.vehicleId = vehicleId;

    if (
      this.ws &&
      (this.ws.readyState === WebSocket.OPEN ||
        this.ws.readyState === WebSocket.CONNECTING)
    ) {
      return;
    }

    this.disconnect();

    try {
      const url = this.WS_URL + "?token=" + encodeURIComponent(authKey);
      this.ws = new WebSocket(url);

      this.ws.onopen = () => {
        this.isConnected = true;
        this.reconnectAttempts = 0;

        try {
          this.ws.send(
            JSON.stringify({
              type: "subscribe",
              action: "driver_subscribe",
              token: authKey,
              driverSno: driverSno,
              vehicleId: vehicleId,
            }),
          );
        } catch (e) {
          console.error("[BookingWS] Failed to send subscribe message:", e);
        }
      };

      this.ws.onmessage = (evt) => {
        try {
          const msg = JSON.parse(evt.data);

          // Handle booking cancellation messages
          if (
            msg.type === "booking_cancelled" ||
            msg.action === "booking_cancelled"
          ) {
            if (this.onBookingCallback) {
              this.onBookingCallback(msg);
            }
            return;
          }

          // Handle status update messages
          if (
            msg.type === "booking_status_update" ||
            msg.type === "status_update" ||
            (msg.bId && msg.status)
          ) {
            // Notify all status update listeners
            this.statusUpdateListeners.forEach((listener) => {
              try {
                listener(msg);
              } catch (e) {
                console.error("[BookingWS] Status update listener error:", e);
              }
            });
          }

          // Handle new booking notifications
          if (
            msg.type === "new_booking" ||
            msg.type === "booking" ||
            msg.dSNo ||
            msg.vId
          ) {
            if (
              msg.dSNo === this.driverSno ||
              msg.vId === this.vehicleId ||
              !msg.dSNo
            ) {
              if (this.onBookingCallback) {
                this.onBookingCallback(msg);
              }
            }
          }
        } catch (e) {
          console.error("[BookingWS] Failed to parse message:", e);
        }
      };

      this.ws.onerror = (err) => {
        console.error("[BookingWS] WebSocket error:", err);
      };

      this.ws.onclose = () => {
        this.isConnected = false;
        this.attemptReconnect();
      };
    } catch (err) {
      console.error("[BookingWS] Connection error:", err);
      this.attemptReconnect();
    }
  }

  /**
   * Send a booking notification (called by employee when submitting a booking)
   */
  sendBooking(bookingData) {
    if (!this.ws || this.ws.readyState !== WebSocket.OPEN) {
      console.warn("[BookingWS] Cannot send booking - WebSocket not open");
      return false;
    }

    try {
      const message = {
        type: "new_booking",
        action: "create_booking",
        ...bookingData,
        timestamp: new Date().toISOString(),
      };
      this.ws.send(JSON.stringify(message));
      return true;
    } catch (e) {
      console.error("[BookingWS] Failed to send booking:", e);
      return false;
    }
  }

  /**
   * Send booking status update (called by driver when changing status)
   * @param {object} statusData - { bId, status, dlatitude, dlongitude, vId, dSNo, ... }
   */
  sendStatusUpdate(statusData) {
    if (!this.ws || this.ws.readyState !== WebSocket.OPEN) {
      console.warn("[BookingWS] Cannot send status update - WebSocket not open");
      return false;
    }

    try {
      const message = {
        type: "booking_status_update",
        action: "update_status",
        ...statusData,
        timestamp: new Date().toISOString(),
      };
      this.ws.send(JSON.stringify(message));
      return true;
    } catch (e) {
      console.error("[BookingWS] Failed to send status update:", e);
      return false;
    }
  }

  /**
   * Send booking cancellation message
   * @param {object} cancellationData - { bId, dSNo, vId, ... }
   */
  sendCancellation(cancellationData) {
    if (!this.ws || this.ws.readyState !== WebSocket.OPEN) {
      console.warn("[BookingWS] Cannot send cancellation - WebSocket not open");
      return false;
    }

    try {
      const message = {
        type: "booking_cancelled",
        action: "booking_cancelled",
        ...cancellationData,
        timestamp: new Date().toISOString(),
      };
      this.ws.send(JSON.stringify(message));
      return true;
    } catch (e) {
      console.error("[BookingWS] Failed to send cancellation:", e);
      return false;
    }
  }

  /**
   * Connect as employee to send bookings
   * @param {string} authKey - authentication token
   */
  connectAsEmployee(authKey) {
    if (!authKey) {
      return;
    }

    this.authKey = authKey;

    if (
      this.ws &&
      (this.ws.readyState === WebSocket.OPEN ||
        this.ws.readyState === WebSocket.CONNECTING)
    ) {
      return;
    }

    this.disconnect();

    try {
      const url = this.WS_URL + "?token=" + encodeURIComponent(authKey);
      this.ws = new WebSocket(url);

      this.ws.onopen = () => {
        this.isConnected = true;
        this.reconnectAttempts = 0;

        try {
          this.ws.send(
            JSON.stringify({
              type: "auth",
              action: "employee_connect",
              token: authKey,
            }),
          );
        } catch (e) {
          console.error("[BookingWS] Failed to send auth message:", e);
        }
      };

      this.ws.onmessage = (evt) => {
        try {
          const msg = JSON.parse(evt.data);

          // Handle status update / cancellation messages
          if (
            msg.type === "booking_status_update" ||
            msg.type === "status_update" ||
            msg.type === "booking_cancelled" ||
            msg.action === "booking_cancelled" ||
            (msg.bId && msg.status)
          ) {
            this.statusUpdateListeners.forEach((listener) => {
              try {
                listener(msg);
              } catch (e) {
                console.error("[BookingWS] Status update listener error:", e);
              }
            });
          }

          // Handle other booking messages
          if (
            msg.type === "new_booking" ||
            msg.type === "booking_accepted" ||
            msg.type === "booking_rejected"
          ) {
            if (this.onBookingCallback) {
              this.onBookingCallback(msg);
            }
          }
        } catch (e) {
          console.error("[BookingWS] Failed to parse message:", e);
        }
      };

      this.ws.onerror = (err) => {
        console.error("[BookingWS] WebSocket error:", err);
      };

      this.ws.onclose = () => {
        this.isConnected = false;
        this.attemptReconnect();
      };
    } catch (err) {
      console.error("[BookingWS] Connection error:", err);
      this.attemptReconnect();
    }
  }

  /**
   * Set callback for when a new booking is received (for drivers)
   * @param {function} callback - function to call with booking data
   */
  onNewBooking(callback) {
    this.onBookingCallback = callback;
  }

  /**
   * Add callback for status updates (supports multiple listeners)
   * @param {function} callback - function to call with status update data
   * @returns {function} unsubscribe function
   */
  onStatusUpdate(callback) {
    if (callback && typeof callback === "function") {
      this.statusUpdateListeners.push(callback);
      return () => {
        this.statusUpdateListeners = this.statusUpdateListeners.filter(
          (cb) => cb !== callback,
        );
      };
    }
    if (callback === null) {
      this.statusUpdateListeners = [];
    }
    return () => {};
  }

  /**
   * Check if WebSocket is ready
   */
  isReady() {
    return this.ws && this.ws.readyState === WebSocket.OPEN;
  }

  /**
   * Attempt to reconnect after connection lost
   */
  attemptReconnect() {
    if (this.reconnectAttempts >= this.maxReconnectAttempts) {
      console.error("[BookingWS] Max reconnection attempts reached");
      return;
    }

    this.reconnectAttempts++;
    console.log(`[BookingWS] Reconnecting attempt ${this.reconnectAttempts}...`);

    setTimeout(() => {
      if (this.driverSno) {
        this.connect(this.authKey, this.driverSno, this.vehicleId);
      } else {
        this.connectAsEmployee(this.authKey);
      }
    }, this.reconnectDelay * this.reconnectAttempts);
  }

  /**
   * Disconnect from WebSocket
   */
  disconnect() {
    if (this.ws) {
      try {
        this.ws.close();
      } catch (e) {
        console.error("[BookingWS] Error closing WebSocket:", e);
      }
      this.ws = null;
    }
    this.isConnected = false;
  }
}

// Export singleton instance
const bookingWS = new BookingWebSocket();
export default bookingWS;